import * as React from "react";
import type { SVGProps } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 186.26 186.26"
    {...props}
  >
    <path
      d="M93.13 8.47c23.27 0 44.43 9.52 59.79 24.87 15.35 15.33 24.88 36.51 24.88 59.79 0 23.29-9.53 44.46-24.87 59.8-15.37 15.34-36.53 24.87-59.8 24.87-23.28 0-44.46-9.53-59.8-24.87-15.34-15.34-24.87-36.51-24.87-59.8 0-23.27 9.53-44.44 24.87-59.78C48.69 17.99 69.86 8.47 93.13 8.47zm0 10.58c-20.37 0-38.9 8.33-52.33 21.75-13.42 13.43-21.75 31.96-21.75 52.33 0 20.37 8.33 38.89 21.76 52.32 13.43 13.43 31.95 21.77 52.32 21.77 20.38 0 38.91-8.33 52.32-21.75 13.43-13.45 21.76-31.97 21.76-52.34 0-20.37-8.33-38.89-21.76-52.32-13.41-13.43-31.94-21.76-52.32-21.76z"
      className="fil0"
    />
    <path
      d="M78.03 62.93V40.21h27.75v22.72H78.03zm-6.53 83.12v-22.31h5.99V92.72H71.5V70.41h37.27v53.33h5.99v22.31H71.5z"
      className="fil0"
    />
  </svg>
);
export default SvgInfo;
